<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
* { box-sizing: border-box; border-color: #cccccc; }
html,body { margin: 0; padding: 0; }
html { font-family: sans-serif; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; }
body { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }

#app { font-family: 'Avenir', Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; text-align: center;  color: #000000; }
input,button { font-family: 'Avenir', Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }


@media screen and (min-width: 601px) {
  .cover { opacity: 1; position: fixed; z-index: 0; top: 0; left: 0; right: 0; bottom: 0; width: 100%; background-size: cover; background-position: center; }
}

.d-flex { display: flex !important; }
.align-items-start { align-items: flex-start }
.container { position: relative; z-index: 1; max-width: 520px; background: #ffffff;}
.btn-default { font-weight: bold; background-color: #393A3D; border-color: #393A3D; color: #ffffff; text-transform: uppercase; display: block; width: 100%; font-size: 18px; padding: 20px 12px; border-radius: 6px; cursor: pointer; outline: 0; }
.btn-close { font-weight: bold; background-color: rgba(255,255,255,0.9); border-color: rgba(0,0,0,0.2); color: #333333; text-transform: uppercase; display: block; width: 100%; font-size: 18px; padding: 20px 12px; border-radius: 6px; cursor: pointer; outline: 0; }
.row { display: table; width: 100%; position: relative; }
.row.border .col { border: 1px solid #c9d4de; }
.row.border .col:first-child { background: #f3f7fb; border-right: 0; border-top-left-radius: 4px; border-bottom-left-radius: 4px; }
.row.border .col:last-child { border-top-right-radius: 4px; border-bottom-right-radius: 4px; }
.row.border .input-text { border: 0 !important; }
.col { display: table-cell; vertical-align: middle; padding: 10px 0; }
.col-40 { width: 40%; }
.col-60 { width: 60%;  }
.col-15 { width: 15%; }
.col-85 { width: 85%; }
.fs-11 { font-size: 11px; }
.fs-14 { font-size: 14px; }
.fs-16 { font-size: 16px; }
.fs-18 { font-size: 18px; }
.fs-20 { font-size: 20px; }
.fs-26 { font-size: 26px; }
.fs-36 { font-size: 36px; }
a.text-black { color: #000000; text-decoration: none; font-weight: bold;}
a.text-black:hover { text-decoration: underline; }
.mw-100 { max-width: 100%; }
.cursor-pointer { cursor: pointer; }
.p-rel { position: relative; }
.d-ib { display: inline-block; }
.p-10 { padding: 10px; }
.m-0 { margin: 0; }
.mt-0 { margin-top: 0; }
.mt-2 { margin-top: 2px; }
.mt-30 { margin-top: 30px; }
.mb-0 { margin-bottom: 0; }
.mb-5 { margin-bottom: 5px; }
.mb-15 { margin-bottom: 15px; }
.mb-20 { margin-bottom: 20px; }
.mb-30 { margin-bottom: 30px; }
.ml-5 { margin-left: 5px; }
.p-30 { padding: 30px; }
.font-weight-bold { font-weight: bold; }
.color-red { color: red; }
.mr-10 { margin-right: 10px; }
.py-0 { padding-top: 0; padding-bottom: 0; }
.py-20 { padding-top: 20px; padding-bottom: 20px; }
.py-30 { padding-top: 30px; padding-bottom: 30px; }
.pt-20 { padding-top: 20px; }
.py-50 { padding-top: 50px; padding-bottom: 50px; }
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.text-14 { font-size: 14px; }
.text-16 { font-size: 16px; }
.lh-34 { line-height: 34px; }
.lh-18 { line-height: 18px; }
.lh-3 { line-height: 3em; }
.lh-1-4 { line-height: 1.4em; }
.lh-1-6 { line-height: 1.6em; }
.lh-2 { line-height: 2em; }
@media screen and (min-width: 601px) {
  #app { padding: 30px 0; }
  .shadowed { box-shadow: 0 2px 15px 5px rgba(0,0,0,0.1); }
  .container { margin: 0 auto; border-radius: 6px;  }
}
@media screen and (max-width: 600px) {
  .container { max-width: 100%; width: 100%; box-shadow: none; border-radius: 0;  margin: 0;  }
}


</style>
